import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";

const FloatingOrange = () => {
  const { t } = useLanguage();
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const show = setTimeout(() => setShowTip(true), 2500);
    const hide = setTimeout(() => setShowTip(false), 9500);
    return () => {
      clearTimeout(show);
      clearTimeout(hide);
    };
  }, []);

  return (
    <motion.div
      className="fixed bottom-6 right-6 z-50 flex items-center group"
      initial={{ scale: 0, rotate: -30 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 16 }}
    >
      <span
        data-testid="orange-tooltip"
        className={`mr-3 bg-white border border-stone rounded-full px-4 py-2 text-sm font-medium text-ink shadow-md whitespace-nowrap hidden sm:block transition-all duration-300 ${
          showTip ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0"
        }`}
      >
        {t.ui.chatTooltip}
      </span>
      <motion.a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat with Marina on WhatsApp"
        animate={{ y: [0, -6, 0] }}
        transition={{ repeat: Infinity, duration: 3.2, ease: "easeInOut" }}
        whileHover={{ scale: 1.1, rotate: -5 }}
        whileTap={{ scale: 0.92 }}
        className="relative block w-14 h-14 md:w-16 md:h-16 rounded-full shadow-lg flex items-center justify-center"
        style={{
          background: "radial-gradient(circle at 32% 26%, #F5A85C 0%, #E8813A 55%, #C96A22 100%)",
          boxShadow: "0 10px 24px rgba(232,129,58,0.45), inset 0 -3px 6px rgba(140,60,10,0.25)",
        }}
      >
        <span
          className="absolute -top-1 left-1/2 -translate-x-1/2 rotate-12 block w-4 h-2.5"
          style={{ background: "#63744F", borderRadius: "100% 4px 100% 4px" }}
          aria-hidden
        />
        <span className="absolute top-1 left-1/2 -translate-x-1/2 w-1.5 h-1 rounded-full bg-[#B25A1B]/60" aria-hidden />
        <MessageCircle size={26} className="text-white drop-shadow-sm" strokeWidth={2.2} aria-hidden />
      </motion.a>
    </motion.div>
  );
};

export default FloatingOrange;
